var exports = {
  "o": "xcc377c0b--97fd00--actions",
};

module.exports = exports;
